import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button, Card, List } from 'antd';
import { Can } from '@app/modules/Auth';
import { useStores } from '@app/hooks/stores';
import { Profile } from '@app/modules/Profiles/Temperature/store';
import TenantItem from '@app/modules/Tenants/components/TenantItem';
import { TenantInterface } from '@app/modules/Tenants/Tenant.interfaces';
import { PlusOutlined } from '@ant-design/icons';

declare type TenantsListProps = {
  profilesList: Profile[];
};

const TenantsList: React.FC<TenantsListProps> = ({ profilesList }) => {
  const { tenantsStore } = useStores();

  useEffect(() => {
    if (!tenantsStore.listTenants.length) {
      tenantsStore.getTenants();
    }
  }, [tenantsStore.listTenants.length === 0]);

  const addBlankItem = () => {
    // @ts-ignore
    tenantsStore.addBlankTenant();
  };

  return (
    <Card
      title="Tenants"
      className="table-card"
      extra={
        <Can
          action="post:tenants"
          yes={() => (
            <Button type="link" icon={<PlusOutlined />} onClick={addBlankItem}>
              Add
            </Button>
          )}
          no={() => null}
        />
      }
    >
      <List
        loading={tenantsStore.loading}
        itemLayout="horizontal"
        size="large"
        pagination={false}
        dataSource={tenantsStore.listTenants}
        renderItem={(item: TenantInterface) => <TenantItem item={item} />}
      />
    </Card>
  );
};

export default observer(TenantsList);
